import { useRecoilValue } from 'recoil';
import { alankaramDataAtom } from '../state';

const useCompanyId = () => {
  const alankaramData = useRecoilValue(alankaramDataAtom);
  return alankaramData.companyId;
};

export default useCompanyId; 